import React from "react";
import { GridContainer, GridHeadline } from "./GridSection.styled";

interface GridSectionProps {
	headline?: string;
	children: React.ReactNode;
	numberOfItems?: number;
}

export const GridSection = ({ headline, children, numberOfItems = 4 }: GridSectionProps) => {
	return (
		<div>
			<GridHeadline>{headline}</GridHeadline>
			<GridContainer style={{ "--number-of-items": numberOfItems } as React.CSSProperties}>{children}</GridContainer>
		</div>
	);
};
